import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";

import { Observable, EMPTY } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { InProgressService } from "./in-progress.service";

import { LOADING_ELEMENT, POSITION_TOP_VALUE } from "./loading-element.token";

@Injectable()
export class InProgressInterceptor implements HttpInterceptor {
  constructor(private injector: Injector) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const inProgressService = this.injector.get(InProgressService);

    const divElement = request.context.get(LOADING_ELEMENT) || '';
    const positionTopValue = request.context.get(POSITION_TOP_VALUE) || '';

    if (divElement !== '') {
      inProgressService.start(divElement, positionTopValue);
    }

    return next.handle(request).pipe(
      catchError((err) => {
        if (divElement !== '') {
          inProgressService.complete(divElement);
        }
        return EMPTY;
      }),
      map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        if (evt instanceof HttpResponse && divElement !== '') {
          inProgressService.complete(divElement);
        }
        return evt;
      })
    );
  }
}
